import { $lang } from 'laravel-vue-lang';

let locale;

try {
  locale = $lang().getLocale();

  if (locale === 'pt_BR') {
    locale = 'pt-BR';
  }
} catch (e) {
  locale = 'pt-BR';
}

export function numberFormat (value, decimal = 2) {
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: decimal,
    maximumFractionDigits: decimal,
  }).format(value || 0);
}
